import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';
import {ListView} from 'shells/list-view/list-view';
import {Percentage} from 'shells/percentage/percentage';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {
    EditionFragment as DripEdition,
    DripSequenceFragment as DripSequence,
    SmsDripEditionFragment as SmsDripEdition,
    SmsDripSequenceFragment as SmsDripSequence,
} from 'nutshell-graphql-types';

import styles from './drip-sequence-engagement.module.css';

type Props = {
    dripSequence: DripSequence | SmsDripSequence;
    editions: DripEdition[] | SmsDripEdition[];
    engagementBar: React.ReactNode;
    renderRow:
        | ((arg1: DripEdition) => React.ReactElement)
        | ((arg1: SmsDripEdition) => React.ReactElement);
};

export function DripSequenceEngagement(props: Props) {
    return (
        <div className={styles['drip-sequence-engagement']}>
            <div className={styles['engagement-container']}>{props.engagementBar}</div>
            <div className={styles['performance-container']}>
                <UppercaseLabel>Performance</UppercaseLabel>
                {props.editions.length && props.dripSequence.status !== 'DRAFT' ? (
                    <div className={styles['performance-stats']}>
                        <div>
                            <span>
                                {/* @ts-expect-error */}
                                <Percentage
                                    value={
                                        props.dripSequence.engagementStats
                                            .dripProgressionsReceivedEveryMessageRate
                                    }
                                />
                            </span>{' '}
                            received every message
                        </div>
                        <div>
                            <span>
                                {/* @ts-expect-error */}
                                <Percentage
                                    value={
                                        props.dripSequence.engagementStats
                                            .dripProgressionsGoalMetRate
                                    }
                                />
                            </span>{' '}
                            met the goal
                        </div>
                    </div>
                ) : undefined}
            </div>
            {props.editions.length ? (
                <div className={styles['message-list-container']}>
                    <ListView
                        renderRow={(edition) => props.renderRow(edition)}
                        collection={props.editions}
                    />
                </div>
            ) : (
                <EmptyStateSmall
                    title='This drip sequence has no messages'
                    subtitle='When you create one or more messages, they’ll show up here'
                    icon={
                        <div style={{width: 80, height: 80}}>
                            <Illustration src='cactus-empty-state' width='100%' height='100%' />
                        </div>
                    }
                />
            )}
        </div>
    );
}
